import {gql} from '@apollo/client';

/**
 * 通用司机筛选下拉（客诉工作台 / POD 审核页共用）；三个入参可空可组合。
 *
 * 不用 delivery 的 getAvailableDrivers* 系列：那些接口 warehouseId 与 dspId 互斥
 * （传了 dspId 会忽略 warehouseId），且鉴权不覆盖 QC 资源码。
 *
 * 条数规则：传了 warehouseId 或 dspIds 时按范围返回（不做 50 条截断），
 * 都不传时是全量司机，只按 keyword 远程搜索前 50 条。
 */
export const GET_DRIVER_OPTIONS = gql`
    query GetDriverOptions($warehouseId: Long, $dspIds: [Long!], $keyword: String) {
        getDriverOptions(warehouseId: $warehouseId, dspIds: $dspIds, keyword: $keyword) {
            accountId
            name
            phone
            dspId
            isEmployed
        }
    }
`;

export interface DriverOption {
    accountId: number;
    name: string;
    phone?: string | null;
    dspId?: number | null;
    /** false 表示已离职；下拉不过滤，仅在文案上标注 */
    isEmployed?: boolean | null;
}

export interface GetDriverOptionsResponse {
    getDriverOptions: DriverOption[];
}

export interface GetDriverOptionsVariables {
    warehouseId?: number | null;
    dspIds?: number[] | null;
    keyword?: string | null;
}

/** 司机下拉展示文案：有电话时拼「姓名 (电话)」，离职额外标注 */
export const formatDriverOptionLabel = (
    driver: DriverOption,
    resignedSuffix: string,
): string => {
    const base = driver.phone ? `${driver.name} (${driver.phone})` : driver.name;
    return driver.isEmployed === false ? `${base}${resignedSuffix}` : base;
};
